module.exports = __webpack_public_path__ + "static/img/m_name.ae40122.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/qa/m_name.png
// module id = 9c4Z
// module chunks = 7